<template>
    <div class="p-4" :style="{ backgroundColor: '#ffffff', border: data.hasRedLine ? '2px solid red' : 'none', borderRadius: data.hasRedLine ? '4px' : '0', padding: data.hasRedLine ? '4px' : '16px' }">
        <hr :style="{ 
            border: 'none', 
            borderTop: `${data.thickness || 2}px ${data.style || 'solid'} ${data.color || '#e5e7eb'}`, 
            width: data.width || '100%', 
            margin: '0' 
        }" />
    </div>
</template>

<script>
export default {
    name: 'DividerBlock',
    props: {
        data: {
            type: Object,
            default: () => ({})
        }
    },
    methods: {
        generateHTML() {
            const thickness = this.data.thickness || 2;
            const style = this.data.style || 'solid';
            const color = this.data.color || '#e5e7eb';
            const width = this.data.width || '100%';
            const margin = this.data.margin || '20px 0';
            
            const styleAttr = this.data.hasRedLine
                ? `@if($show_clues) style="margin: ${margin}; border: solid red 2px; padding: 4px;" @else style="margin: ${margin};" @endif`
                : `style="margin: ${margin};"`;
            
            return `
                <table width="100%" border="0" cellspacing="0" cellpadding="0" ${styleAttr}>
                    <tr>
                        <td align="center" style="padding: 0;">
                            <table width="${width}" border="0" cellspacing="0" cellpadding="0" align="center">
                                <tr>
                                    <td height="${thickness}" bgcolor="${color}" style="height: ${thickness}px; background-color: ${color}; line-height: ${thickness}px; font-size: 1px;">&nbsp;</td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>
            `;
        },
        getDefaultData() {
            return {
                thickness: 2,
                color: '#e5e7eb',
                style: 'solid',
                width: '100%',
                margin: '20px 0',
                hasRedLine: false
            };
        }
    }
}
</script>